<template>
  <div class="header-bar">
    <v-app-bar-nav-icon
      class="burger-bar"
      @click.stop="toggleOpen"
    ></v-app-bar-nav-icon>
    <h1 class="app-name">Babynamr</h1>
    <v-icon>{{ babyIcon }}</v-icon>
  </div>
</template>

<script>
import { mdiBabyFaceOutline } from "@mdi/js";

export default {
  name: "HeaderBar",
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      babyIcon: mdiBabyFaceOutline
    };
  },

  methods: {
    toggleOpen() {
      this.$emit("toggle-open");
    }
  }
};
</script>

<style lang="scss" scoped>
.header-bar {
  height: var(--header-height);
  background-color: var(--primary-colour);
  display: flex;
  align-items: center;
  width: 100vw;
  color: rgba(255, 255, 255, 0.8);
}

::v-deep .v-btn__content {
  color: rgba(255, 255, 255, 0.8);
}
::v-deep .theme--light.v-icon {
  color: rgba(255, 255, 255, 0.8);
}
.app-name {
  flex-grow: 1;
}
</style>